import React, { useState, useEffect } from "react";
import api from "../services/api";
import AddInstitutionModal from "./AddInstitutionModal";
import "./componentStyles/AddUnitModal.css";

function AddUnitModal({ isOpen, onClose }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    ustKurum: "",
    birimAdi: "",
    sifre: "",
    ogrenciSayisi: 1
  });
  
  const [workplaces, setWorkplaces] = useState([
    { calisacakYer: "", isAdi: "", kapasite: 1 }
  ]);
  
  const [institutions, setInstitutions] = useState([]);
  const [isInstitutionModalOpen, setIsInstitutionModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Üst kurumları getir
  const fetchInstitutions = async () => {
    try {
      const response = await api.get("/admin/upper-institutions");
      if (response.data.success) {
        setInstitutions(response.data.data);
      }
    } catch (error) {
      console.error("Üst kurumlar getirilirken hata:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchInstitutions();
    }
  }, [isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWorkplaceChange = (index, field, value) => {
    const updatedWorkplaces = [...workplaces];
    if (field === 'kapasite') {
      updatedWorkplaces[index][field] = Math.max(1, parseInt(value) || 1);
    } else {
      updatedWorkplaces[index][field] = value;
    }
    setWorkplaces(updatedWorkplaces);
  };

  const addWorkplace = () => {
    setWorkplaces([...workplaces, { calisacakYer: "", isAdi: "", kapasite: 1 }]);
  };

  const removeWorkplace = (index) => {
    if (workplaces.length > 1) {
      const updatedWorkplaces = workplaces.filter((_, i) => i !== index);
      setWorkplaces(updatedWorkplaces);
    }
  };

  const getTotalCapacity = () => {
    return workplaces.reduce((total, workplace) => total + workplace.kapasite, 0);
  };

  const getCapacityStatus = () => {
    const total = getTotalCapacity();
    const required = formData.ogrenciSayisi;
    
    if (total === required) {
      return { status: 'success', message: `Kapasite uygun: ${total}/${required}` };
    } else if (total < required) {
      return { status: 'warning', message: `Kapasite eksik: ${total}/${required} (${required - total} eksik)` };
    } else {
      return { status: 'warning', message: `Kapasite fazla: ${total}/${required} (${total - required} fazla)` };
    }
  };

  const increaseCount = () => {
    setFormData(prev => ({
      ...prev,
      ogrenciSayisi: prev.ogrenciSayisi + 1
    }));
  };

  const decreaseCount = () => {
    if (formData.ogrenciSayisi > 1) {
      setFormData(prev => ({
        ...prev,
        ogrenciSayisi: prev.ogrenciSayisi - 1
      }));
    }
  };

  const handleStep1Submit = (e) => {
    e.preventDefault();
    setCurrentStep(2);
  };



  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Sadece 8 karakter kontrolü
    if (typeof formData.sifre !== "string" || formData.sifre.length < 8) {
      setError("Şifre en az 8 karakter olmalıdır.");
      setLoading(false);
      return;
    }

    try {
      const finalData = {
        ustKurum: formData.ustKurum,
        birimAdi: formData.birimAdi,
        sifre: formData.sifre,
        ogrenciSayisi: formData.ogrenciSayisi,
        workplaces: workplaces,
        totalCapacity: getTotalCapacity()
      };

      const response = await api.post("/admin/units", finalData);

      if (response.data.success) {
        console.log("Birim başarıyla eklendi:", response.data.data);
        handleClose();
        // Başarı mesajı gösterilebilir
      }
    } catch (error) {
      setError(error.response?.data?.message || "Birim eklenirken hata oluştu");
      console.error("Unit creation error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  const handleClose = () => {
    setCurrentStep(1);
    setFormData({
      ustKurum: "",
      birimAdi: "",
      sifre: "",
      ogrenciSayisi: 1
    });
    setWorkplaces([{ calisacakYer: "", isAdi: "", kapasite: 1 }]);
    onClose();
  };

  const openInstitutionModal = () => {
    setIsInstitutionModalOpen(true);
  };

  const closeInstitutionModal = () => {
    setIsInstitutionModalOpen(false);
  };

  const handleInstitutionAdded = (created) => {
    // Refresh the list and select the newly created upper institution
    fetchInstitutions();
    if (created && created._id) {
      setFormData(prev => ({ ...prev, ustKurum: created._id }));
    }
    closeInstitutionModal();
  };

  const capacitiesMatch = getTotalCapacity() === formData.ogrenciSayisi;

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal-overlay"
        onClick={isInstitutionModalOpen ? undefined : handleClose}
      >
        <div
          className={`modal-content ${currentStep === 2 ? 'modal-content-step2' : ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
          
          {currentStep === 1 && (
            <form onSubmit={handleStep1Submit} className="modal-form">
              <div className="form-group">
                <div className="select-with-button">
                  <select 
                    name="ustKurum"
                    value={formData.ustKurum}
                    onChange={handleInputChange}
                    className="form-select"
                    required
                  >
                    <option value="">Birimin bağlı olduğu üst kurumu seçiniz ...</option>
                    {institutions.map((institution) => (
                      <option key={institution._id} value={institution._id}>
                        {institution.ustKurum}
                      </option>
                    ))}
                  </select>
                  <button 
                    type="button" 
                    className="add-institution-btn"
                    onClick={openInstitutionModal}
                    title="Yeni üst kurum ekle"
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="form-group form-row">
                <input
                  type="text"
                  name="birimAdi"
                  value={formData.birimAdi}
                  onChange={handleInputChange}
                  placeholder="Birim Adı ..."
                  className="form-input"
                  required
                />
                
                <div className="counter-group">
                  <button 
                    type="button" 
                    className="counter-btn minus"
                    onClick={decreaseCount}
                  >
                    -
                  </button>
                  <span className="counter-value">{formData.ogrenciSayisi}</span>
                  <button 
                    type="button" 
                    className="counter-btn plus"
                    onClick={increaseCount}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="sifre"
                  value={formData.sifre}
                  onChange={handleInputChange}
                  placeholder="Birim için Şifre Oluşturunuz ..."
                  className="form-input"
                  required
                />
                {/* Şifre uyarısı burada gösterilecek */}
                {error && (
                  <div className="error-message" style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '8px',
                    borderRadius: '5px',
                    marginTop: '8px',
                    textAlign: 'center',
                    border: '1px solid #f5c6cb',
                    fontSize: '13px'
                  }}>
                    {error}
                  </div>
                )}
              </div>

              <div className="form-group">
                <button type="submit" className="submit-btn2">
                  Devam →
                </button>
              </div>
            </form>
          )}

          {currentStep === 2 && (
            <>
              <form onSubmit={handleFinalSubmit} className="modal-form-step2">
                <div className="capacity-summary">
                  <button
                    type="button"
                    className="back-btn"
                    onClick={handleBack}
                  >
                    <i class="fa-solid fa-circle-left"></i>
                  </button>
                  <span className={getCapacityStatus().status === 'success' ? 'capacity-success' : 'capacity-warning'}>
                    {getCapacityStatus().message}
                  </span>
                </div>

                <div className="employees-container">
                  {workplaces.map((workplace, index) => (
                    <div key={index} className="employee-row">
                      <div className="employee-inputs">
                        <input
                          type="text"
                          value={workplace.calisacakYer}
                          onChange={(e) => handleWorkplaceChange(index, "calisacakYer", e.target.value)}
                          placeholder="Çalışılacak Yeri Giriniz ..."
                          className="employee-input"
                          required
                        />
                        <input
                          type="text"
                          value={workplace.isAdi}
                          onChange={(e) => handleWorkplaceChange(index, "isAdi", e.target.value)}
                          placeholder="İşin Adını / Niteliğini Giriniz ..."
                          className="employee-input"
                          required
                        />
                        <div className="employee-capacity">
                          <span>Bu yerde bu işte çalışacak kişi sayısı:</span>
                          <div className="capacity-counter-group">
                            <button 
                              type="button" 
                              className="capacity-counter-btn minus"
                              onClick={() => handleWorkplaceChange(index, "kapasite", workplace.kapasite - 1)}
                            >
                              -
                            </button>
                            <span className="capacity-counter-value">{workplace.kapasite}</span>
                            <button 
                              type="button" 
                              className="capacity-counter-btn plus"
                              onClick={() => handleWorkplaceChange(index, "kapasite", workplace.kapasite + 1)}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      {workplaces.length > 1 && (
                        <button
                          type="button"
                          className="remove-workplace-btn"
                          onClick={() => removeWorkplace(index)}
                        >
                          ×
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {!capacitiesMatch && (
                  <div
                    style={{
                      marginTop: 10,
                      padding: '10px 12px',
                      borderRadius: 8,
                      background: '#fff4f4',
                      color: '#b71c1c',
                      border: '1px solid #ffcdd2',
                      fontSize: 13
                    }}
                  >
                    Toplam kontenjan ile çalışma yerlerinin toplam kapasitesi eşit değil. Lütfen kapasiteyi {formData.ogrenciSayisi} olacak şekilde ayarlayın.
                  </div>
                )}

                {error && (
                  <div className="error-message" style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '10px',
                    borderRadius: '5px',
                    marginBottom: '15px',
                    textAlign: 'center',
                    border: '1px solid #f5c6cb'
                  }}>
                    {error}
                  </div>
                )}

                <div className="form-actions">
                  <button
                    type="button"
                    className="add-workplace-btn"
                    onClick={addWorkplace}
                    disabled={loading}
                  >
                    + Çalışma Yeri Ekle
                  </button>
                  <button 
                    type="submit" 
                    className="submit-btn-step2"
                    disabled={loading || !capacitiesMatch}
                    title={!capacitiesMatch ? "Toplam kapasite eşleşmiyor" : undefined}
                  >
                    {loading ? "Kaydediliyor..." : "Onayla ✓"}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>

      <AddInstitutionModal 
        isOpen={isInstitutionModalOpen} 
        onClose={closeInstitutionModal}
        onInstitutionAdded={handleInstitutionAdded}
      />
    </>
  );
}

export default AddUnitModal;


